export const defaultVatCoefficient = 100;
